import { render, staticRenderFns } from "./workerSinglesPrinting.vue?vue&type=template&id=15fc2d50&scoped=true&"
import script from "./workerSinglesPrinting.vue?vue&type=script&lang=js&"
export * from "./workerSinglesPrinting.vue?vue&type=script&lang=js&"
import style0 from "./workerSinglesPrinting.vue?vue&type=style&index=0&id=15fc2d50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fc2d50",
  null
  
)

export default component.exports